import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

export const MobileContainer = styled('div')(({ theme }) => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    position: 'fixed',
    bottom: '0',
    left: '0',
    right: '0',
    padding: '16px',
    gap: '16px',
    backgroundColor: theme.palette.neutral[0],
    zIndex: 20,
    transition: 'transform .2s',
    boxShadow: '0 -4px 16px 0 rgba(8, 33, 66, 0.05)',

    '& > *': {
      flex: '1 1 auto',
    },

    '&.closed': {
      transform: 'translateY(100%)',
    },
  };
});

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '-40px',
  right: '0',
  backgroundColor: theme.palette.neutral[0],
  borderRadius: '8px 8px 0 0',
  boxShadow: '0 -4px 16px 0 rgba(8, 33, 66, 0.05)',
}));
